module.exports = __webpack_public_path__ + "static/media/templates-grey.173499db.svg";